import { DriverPayRateDetails } from "../DriverPayRateDetails";
import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverPayRateSlideout extends Layout {
    layoutPayRateDetail: DriverPayRateDetails;
    sourceDrsPayrate: DataSource;
    sourceDrsPayrateHeader: DataSource;
    textboxCustomerId: Textbox;
    textboxEffectiveDt: Textbox;
    textboxExpirationDt: Textbox;
}
